document.addEventListener('DOMContentLoaded', () => {
    const productMediaGallerySlider = new Swiper('.product-gallery__slider', {
        slidesPerView: 1,
        pagination: {
            el: '.product-gallery__slider .swiper-pagination',
            clickable: true
        }, breakpoints: {
            768: {
                enabled: false
            }
        }
    });
});